import React from 'react';
import { isLpgProcurement } from '../../../../../../../shared/offer-domain/constants';
import OfferTableNonLpg from './nonLpg/OfferTableNonLpg';
import OfferTableLpg from './lpg/OfferTableLpg';
import '../../../../../TenderEvaluation.css';

const OfferTable = ({
  viewMode = 'offer',
  selectionDisabled = false,
  alphaImprovementEditable = false,
  onAlphaImprovementChange,
  onImprovementMeta,
  focusParcelId,
  focusRequirementIndex,
  ...props
}) => {
  if (isLpgProcurement(props.procurement)) {
    return (
      <OfferTableLpg
        viewMode={viewMode}
        selectionDisabled={selectionDisabled}
        alphaImprovementEditable={alphaImprovementEditable}
        onAlphaImprovementChange={onAlphaImprovementChange}
        onImprovementMeta={onImprovementMeta}
        focusParcelId={focusParcelId}
        focusRequirementIndex={focusRequirementIndex}
        {...props}
      />
    );
  }

  return (
    <OfferTableNonLpg
      viewMode={viewMode}
      selectionDisabled={selectionDisabled}
      alphaImprovementEditable={alphaImprovementEditable}
      onAlphaImprovementChange={onAlphaImprovementChange}
      onImprovementMeta={onImprovementMeta}
      focusParcelId={focusParcelId}
      focusRequirementIndex={focusRequirementIndex}
      {...props}
    />
  );
};

export default OfferTable;
